var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriterionSelectorDialog", {
        attrs: { viewModel: _vm.criterionSelectorDialog },
        on: {
          "confirm-selection": function ($event) {
            _vm.criterionId = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass: "navbar navbar-light navbar-expand-md",
          staticStyle: {
            "background-color": "rgba(0, 0, 0, 0.03)",
            border: "1px solid rgba(0, 0, 0, 0.125)",
            "border-bottom": "0",
          },
          attrs: { role: "navigation" },
        },
        [
          _c("ul", { staticClass: "navbar-nav mr-2" }, [
            _c("li", { staticClass: "dropdown" }, [
              _c("div", { staticClass: "navbar-form" }, [
                _c("div", { staticClass: "btn-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary dropdown-toggle",
                      attrs: { "data-toggle": "dropdown" },
                    },
                    [_vm._v(_vm._s(_vm.projectsDataView))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-menu" }, [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            _vm.projectsDataView = "CBA"
                          },
                        },
                      },
                      [_vm._v("Cost-Benefit Analysis")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            _vm.projectsDataView = "RAG"
                          },
                        },
                      },
                      [_vm._v("Heatmap")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            _vm.projectsDataView = "Ranking"
                          },
                        },
                      },
                      [_vm._v("Ranking")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            _vm.projectsDataView = "H2H"
                          },
                        },
                      },
                      [_vm._v("Compare scenarios")]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.criteriaFilterVisible === true
              ? _c("li", { staticClass: "dropdown ml-2" }, [
                  _c("div", { staticClass: "navbar-form" }, [
                    _c("div", { staticClass: "btn-group" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-secondary dropdown-toggle",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [_vm._v(_vm._s(_vm.criteriaFilter))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                _vm.criteriaFilter = "Objectives"
                              },
                            },
                          },
                          [_vm._v("Objectives (top)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                _vm.criteriaFilter = "Attributes"
                              },
                            },
                          },
                          [_vm._v("Attributes (bottom)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                _vm.criteriaFilter = "All criteria"
                              },
                            },
                          },
                          [_vm._v("All criteria")]
                        ),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.criterionSelectorVisible === true
              ? _c("li", { staticClass: "dropdown ml-2" }, [
                  _c("div", { staticClass: "navbar-form" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.showCriterionSelector },
                      },
                      [_vm._v("Criterion")]
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.valueFilterVisible === true
              ? _c("li", { staticClass: "dropdown ml-2" }, [
                  _c("div", { staticClass: "navbar-form" }, [
                    _c("div", { staticClass: "dropdown" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-secondary dropdown-toggle",
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [_vm._v("Value: " + _vm._s(_vm.valueFilter ?? "Any"))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dropdown-menu",
                          staticStyle: {
                            "max-height": "250px",
                            "overflow-y": "auto",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  _vm.valueFilter = null
                                },
                              },
                            },
                            [_vm._v("All")]
                          ),
                          _vm._v(" "),
                          _c("h6", { staticClass: "dropdown-header" }, [
                            _vm._v("By value"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  _vm.valueFilter = 75
                                },
                              },
                            },
                            [_vm._v("Above 75")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  _vm.valueFilter = 50
                                },
                              },
                            },
                            [_vm._v("Above 50")]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "navbar-nav ml-auto mr-2" }, [
            _c("li", { staticClass: "dropdown" }, [
              _c("div", { staticClass: "navbar-form" }, [
                _c("div", { staticClass: "btn-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary dropdown-toggle",
                      attrs: { "data-toggle": "dropdown" },
                    },
                    [_vm._v("Filter: " + _vm._s(_vm.projectsFilter))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-menu" }, [
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.updateProjectsFilter("All")
                          },
                        },
                      },
                      [_vm._v("All")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-divider" }),
                    _vm._v(" "),
                    _c("h6", { staticClass: "dropdown-header" }, [
                      _vm._v("Filter by status:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.updateProjectsFilter("TBD")
                          },
                        },
                      },
                      [_vm._v("TBD")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.updateProjectsFilter("Accepted")
                          },
                        },
                      },
                      [_vm._v("Accepted")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-item",
                        on: {
                          click: function ($event) {
                            return _vm.updateProjectsFilter("Rejected")
                          },
                        },
                      },
                      [_vm._v("Rejected")]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "form-inline my-2 my-lg-0",
              attrs: { role: "search" },
            },
            [
              _c("input", {
                staticClass: "form-control mr-sm-2",
                attrs: { type: "search", placeholder: "Search" },
                domProps: { value: _vm.searchPhrase },
                on: {
                  input: function ($event) {
                    return _vm.updateSearchPhrase($event.target.value)
                  },
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.projectsDataView === "CBA"
        ? _c("div", [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", { staticClass: "table table-hover" }, [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticClass: "align-middle",
                        staticStyle: {
                          "min-width": "300px",
                          width: "300px",
                          "max-width": "300px",
                        },
                      },
                      [_vm._v("Project")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-center align-middle",
                        staticStyle: {
                          "min-width": "100px",
                          width: "100px",
                          "max-width": "100px",
                        },
                      },
                      [_vm._v("P&L")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-center align-middle",
                        staticStyle: {
                          "min-width": "250px",
                          width: "250px",
                          "max-width": "250px",
                        },
                      },
                      [_vm._v("Selection")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-center align-middle",
                        staticStyle: {
                          "min-width": "200px",
                          width: "200px",
                          "max-width": "200px",
                        },
                      },
                      [
                        _vm._v("Cost of value point "),
                        _c("br"),
                        _vm._v(" (" + _vm._s(_vm.currencyLabel) + ")"),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-right align-middle",
                        staticStyle: { "min-width": "250px", width: "auto" },
                      },
                      [
                        _vm._v("Costs "),
                        _c("br"),
                        _vm._v(" (" + _vm._s(_vm.currencyLabel) + ")"),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.projects, function (a) {
                    return _c("tr", { key: a.Id }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "min-width": "300px",
                            width: "300px",
                            "max-width": "300px",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: a.DashboardUrl,
                                  expression: "a.DashboardUrl",
                                },
                              ],
                              staticClass: "text-primary",
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(a.Name) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "100px",
                            width: "100px",
                            "max-width": "100px",
                          },
                        },
                        [
                          a.HasActivePlan
                            ? _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: a.PnlUrl,
                                      expression: "a.PnlUrl",
                                    },
                                  ],
                                  staticClass: "text-primary",
                                },
                                [
                                  _vm._v(
                                    "\n                                View\n                            "
                                  ),
                                ]
                              )
                            : _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: a.PlansUrl,
                                      expression: "a.PlansUrl",
                                    },
                                  ],
                                  staticClass: "text-danger",
                                },
                                [
                                  _vm._v(
                                    "\n                                NA\n                            "
                                  ),
                                ]
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "250px",
                            width: "250px",
                            "max-width": "250px",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group mr-2",
                              attrs: { role: "group" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  class: _vm.getAcceptanceButtonCss(
                                    a,
                                    "Accepted"
                                  ),
                                  attrs: {
                                    type: "button",
                                    disabled: a.UiAcceptanceLocked === true,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.acceptSelection(a)
                                    },
                                  },
                                },
                                [_vm._v("Accept")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  class: _vm.getAcceptanceButtonCss(
                                    a,
                                    "Rejected"
                                  ),
                                  attrs: {
                                    type: "button",
                                    disabled: a.UiAcceptanceLocked === true,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rejectSelection(a)
                                    },
                                  },
                                },
                                [_vm._v("Reject")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          a.UiAcceptanceLocked === true
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  on: {
                                    click: function ($event) {
                                      return _vm.unlockSelection(a)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa-solid fa-lock" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          a.UiAcceptanceLocked === false
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: {
                                    title: "Click to lock selection status",
                                    disabled: a.UiAcceptance === "TBD",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.lockSelection(a)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-lock-open",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "200px",
                            width: "200px",
                            "max-width": "200px",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(a.CostOfValuePointString) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-right align-middle",
                          staticStyle: { "min-width": "250px", width: "auto" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "progress justify-content-end",
                              staticStyle: { height: "30px" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "progress-bar bg-danger",
                                  style: { width: a.NormalizedTotalCost + "%" },
                                  attrs: { role: "progressbar" },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(a.TotalCostString) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "align-middle",
                          staticStyle: { "min-width": "250px", width: "auto" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "progress",
                              staticStyle: { height: "30px" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "progress-bar bg-success",
                                  style: { width: a.TotalValue + "%" },
                                  attrs: { role: "progressbar" },
                                },
                                [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(a.TotalValueString) +
                                      "\n                                "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.projectsDataView === "RAG"
        ? _c("div", [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", { staticClass: "table table-hover" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c(
                        "th",
                        {
                          staticClass: "align-middle",
                          staticStyle: {
                            "min-width": "300px",
                            width: "300px",
                            "max-width": "300px",
                          },
                        },
                        [_vm._v("Project")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "100px",
                            width: "100px",
                            "max-width": "100px",
                          },
                        },
                        [_vm._v("P&L")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "250px",
                            width: "250px",
                            "max-width": "250px",
                          },
                        },
                        [_vm._v("Selection")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.criteria, function (c) {
                        return _c(
                          "th",
                          {
                            key: c.Id,
                            staticClass: "text-center align-middle",
                            staticStyle: {
                              "min-width": "300px",
                              width: "auto",
                            },
                          },
                          [_vm._v(_vm._s(c.Name))]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.projects, function (a) {
                    return _c(
                      "tr",
                      { key: a.Id },
                      [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "min-width": "300px",
                              width: "300px",
                              "max-width": "300px",
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: a.DashboardUrl,
                                    expression: "a.DashboardUrl",
                                  },
                                ],
                                staticClass: "text-primary",
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(a.Name) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-center align-middle",
                            staticStyle: {
                              "min-width": "100px",
                              width: "100px",
                              "max-width": "100px",
                            },
                          },
                          [
                            a.HasActivePlan
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: a.PnlUrl,
                                        expression: "a.PnlUrl",
                                      },
                                    ],
                                    staticClass: "text-primary",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                View\n                            "
                                    ),
                                  ]
                                )
                              : _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: a.PlansUrl,
                                        expression: "a.PlansUrl",
                                      },
                                    ],
                                    staticClass: "text-danger",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                NA\n                            "
                                    ),
                                  ]
                                ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-center align-middle",
                            staticStyle: {
                              "min-width": "250px",
                              width: "250px",
                              "max-width": "250px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group mr-2",
                                attrs: { role: "group" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    class: _vm.getAcceptanceButtonCss(
                                      a,
                                      "Accepted"
                                    ),
                                    attrs: {
                                      type: "button",
                                      disabled: a.UiAcceptanceLocked === true,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.acceptSelection(a)
                                      },
                                    },
                                  },
                                  [_vm._v("Accept")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    class: _vm.getAcceptanceButtonCss(
                                      a,
                                      "Rejected"
                                    ),
                                    attrs: {
                                      type: "button",
                                      disabled: a.UiAcceptanceLocked === true,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.rejectSelection(a)
                                      },
                                    },
                                  },
                                  [_vm._v("Reject")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            a.UiAcceptanceLocked === true
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary btn-sm",
                                    on: {
                                      click: function ($event) {
                                        return _vm.unlockSelection(a)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "fa-solid fa-lock" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            a.UiAcceptanceLocked === false
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary btn-sm",
                                    attrs: {
                                      title: "Click to lock selection status",
                                      disabled: a.UiAcceptance === "TBD",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.lockSelection(a)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-lock-open",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.criteria, function (c) {
                          return _c(
                            "td",
                            {
                              key: c.Id,
                              staticClass: "text-center align-middle",
                              class: _vm.getRagClass(
                                a.NormalizedCriteriaValues[c.ValueIndex]
                              ),
                              staticStyle: {
                                "min-width": "300px",
                                width: "auto",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.formatValue(
                                      a.NormalizedCriteriaValues[c.ValueIndex]
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.projectsDataView === "H2H"
        ? _c("div", [
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", { staticClass: "table table-bordered table-hover" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c(
                        "th",
                        {
                          staticClass: "align-middle",
                          staticStyle: {
                            "min-width": "300px",
                            width: "300px",
                            "max-width": "300px",
                          },
                        },
                        [_vm._v("Project")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "100px",
                            width: "100px",
                            "max-width": "100px",
                          },
                        },
                        [_vm._v("P&L")]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "250px",
                            width: "250px",
                            "max-width": "250px",
                          },
                        },
                        [_vm._v("Selection")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.comparableScenarios, function (s) {
                        return _c("th", { key: s.Id }, [_vm._v(_vm._s(s.Name))])
                      }),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.comparableProjects, function (a) {
                    return _c(
                      "tr",
                      { key: a.Id },
                      [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "min-width": "300px",
                              width: "300px",
                              "max-width": "300px",
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: a.DashboardUrl,
                                    expression: "a.DashboardUrl",
                                  },
                                ],
                                staticClass: "text-primary",
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(a.Name) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-center align-middle",
                            staticStyle: {
                              "min-width": "100px",
                              width: "100px",
                              "max-width": "100px",
                            },
                          },
                          [
                            a.HasActivePlan
                              ? _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: a.PnlUrl,
                                        expression: "a.PnlUrl",
                                      },
                                    ],
                                    staticClass: "text-primary",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                View\n                            "
                                    ),
                                  ]
                                )
                              : _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "sanitizedHref",
                                        rawName: "v-sanitizedHref",
                                        value: a.PlansUrl,
                                        expression: "a.PlansUrl",
                                      },
                                    ],
                                    staticClass: "text-danger",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                NA\n                            "
                                    ),
                                  ]
                                ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-center align-middle",
                            staticStyle: {
                              "min-width": "250px",
                              width: "250px",
                              "max-width": "250px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "btn-group mr-2",
                                attrs: { role: "group" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    class: _vm.getAcceptanceButtonCss(
                                      a,
                                      "Accepted"
                                    ),
                                    attrs: {
                                      type: "button",
                                      disabled: a.UiAcceptanceLocked === true,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.acceptSelection(a)
                                      },
                                    },
                                  },
                                  [_vm._v("Accept")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    class: _vm.getAcceptanceButtonCss(
                                      a,
                                      "Rejected"
                                    ),
                                    attrs: {
                                      type: "button",
                                      disabled: a.UiAcceptanceLocked === true,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.rejectSelection(a)
                                      },
                                    },
                                  },
                                  [_vm._v("Reject")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            a.UiAcceptanceLocked === true
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary btn-sm",
                                    on: {
                                      click: function ($event) {
                                        return _vm.unlockSelection(a)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "fa-solid fa-lock" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            a.UiAcceptanceLocked === false
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-secondary btn-sm",
                                    attrs: {
                                      title: "Click to lock selection status",
                                      disabled: a.UiAcceptance === "TBD",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.lockSelection(a)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-solid fa-lock-open",
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.comparableScenarios, function (s) {
                          return _c(
                            "td",
                            {
                              key: s.Id,
                              staticClass: "align-middle",
                              class: _vm.getCompareAcceptanceClass(
                                a.ComparableScenariosAcceptance[s.ValueIndex]
                              ),
                              staticStyle: {
                                "min-width": "250px",
                                width: "auto",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    a.ComparableScenariosAcceptance[
                                      s.ValueIndex
                                    ]
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.projectsDataView === "Ranking"
        ? _c("div", [
            _c(
              "table",
              { staticClass: "table table-bordered table-hover mt-2" },
              [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        staticClass: "align-middle",
                        staticStyle: {
                          "min-width": "300px",
                          width: "300px",
                          "max-width": "300px",
                        },
                      },
                      [_vm._v("Project")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-center align-middle",
                        staticStyle: {
                          "min-width": "100px",
                          width: "100px",
                          "max-width": "100px",
                        },
                      },
                      [_vm._v("P&L")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-center align-middle",
                        staticStyle: {
                          "min-width": "250px",
                          width: "250px",
                          "max-width": "250px",
                        },
                      },
                      [_vm._v("Selection")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "text-center align-middle",
                        staticStyle: {
                          "min-width": "150px",
                          width: "150px",
                          "max-width": "150px",
                        },
                      },
                      [_vm._v("Value")]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "align-middle",
                        staticStyle: { "min-width": "250px", width: "auto" },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.criterionLabel) +
                            "\n                        "
                        ),
                        _vm.selectedCriterion.IsBottom === false
                          ? _c("div", { staticClass: "float-right" }, [
                              _c(
                                "div",
                                { staticClass: "dropdown d-inline mr-2" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-secondary btn-sm",
                                      attrs: { "data-toggle": "dropdown" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Legend\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-menu dropdown-menu-right",
                                      staticStyle: { width: "300px" },
                                      attrs: { role: "menu" },
                                    },
                                    _vm._l(_vm.subcriteria, function (c) {
                                      return _c(
                                        "span",
                                        {
                                          key: c.Id,
                                          staticClass:
                                            "dropdown-item-text font-weight-normal",
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-square",
                                            style: {
                                              color: _vm.getCriterionColor(c),
                                            },
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(c.Name) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.rankingProjects, function (a) {
                    return _c("tr", { key: a.Id }, [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            "min-width": "300px",
                            width: "300px",
                            "max-width": "300px",
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: a.DashboardUrl,
                                  expression: "a.DashboardUrl",
                                },
                              ],
                              staticClass: "text-primary",
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(a.Name) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "100px",
                            width: "100px",
                            "max-width": "100px",
                          },
                        },
                        [
                          a.HasActivePlan
                            ? _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: a.PnlUrl,
                                      expression: "a.PnlUrl",
                                    },
                                  ],
                                  staticClass: "text-primary",
                                },
                                [
                                  _vm._v(
                                    "\n                            View\n                        "
                                  ),
                                ]
                              )
                            : _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: a.PlansUrl,
                                      expression: "a.PlansUrl",
                                    },
                                  ],
                                  staticClass: "text-danger",
                                },
                                [
                                  _vm._v(
                                    "\n                            NA\n                        "
                                  ),
                                ]
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "250px",
                            width: "250px",
                            "max-width": "250px",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group mr-2",
                              attrs: { role: "group" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  class: _vm.getAcceptanceButtonCss(
                                    a,
                                    "Accepted"
                                  ),
                                  attrs: {
                                    type: "button",
                                    disabled: a.UiAcceptanceLocked === true,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.acceptSelection(a)
                                    },
                                  },
                                },
                                [_vm._v("Accept")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  class: _vm.getAcceptanceButtonCss(
                                    a,
                                    "Rejected"
                                  ),
                                  attrs: {
                                    type: "button",
                                    disabled: a.UiAcceptanceLocked === true,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.rejectSelection(a)
                                    },
                                  },
                                },
                                [_vm._v("Reject")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          a.UiAcceptanceLocked === true
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  on: {
                                    click: function ($event) {
                                      return _vm.unlockSelection(a)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa-solid fa-lock" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          a.UiAcceptanceLocked === false
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: {
                                    title: "Click to lock selection status",
                                    disabled: a.UiAcceptance === "TBD",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.lockSelection(a)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-solid fa-lock-open",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-center align-middle",
                          staticStyle: {
                            "min-width": "150px",
                            width: "150px",
                            "max-width": "150px",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.formatValue(
                                  a.NormalizedCriteriaValues[
                                    _vm.selectedCriterion.ValueIndex
                                  ]
                                )
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        !_vm.selectedCriterion.IsBottom
                          ? _c(
                              "div",
                              {
                                staticClass: "progress",
                                staticStyle: { height: "30px" },
                              },
                              _vm._l(_vm.subcriteria, function (c) {
                                return _c("div", {
                                  key: c.Id,
                                  staticClass: "progress-bar",
                                  class: _vm.getCriterionBarColor(c),
                                  style: {
                                    width:
                                      a.LocalWeightedCriteriaValues[
                                        c.ValueIndex
                                      ] + "%",
                                  },
                                  attrs: { title: c.Name, role: "progressbar" },
                                })
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.selectedCriterion.IsBottom
                          ? _c(
                              "div",
                              {
                                staticClass: "progress",
                                staticStyle: { height: "30px" },
                              },
                              [
                                _c("div", {
                                  staticClass: "progress-bar",
                                  style: {
                                    width:
                                      a.NormalizedCriteriaValues[
                                        _vm.selectedCriterion.ValueIndex
                                      ] + "%",
                                  },
                                  attrs: { role: "progressbar" },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "th",
      {
        staticClass: "align-middle",
        staticStyle: { "min-width": "250px", width: "auto" },
      },
      [_vm._v("Value "), _c("br"), _vm._v(" (0-100)")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }